import { getOscConfig } from "./oneSupportCenterEnv/oneSupportCenterEnv";

const { helpCenterApiEndpoint } = getOscConfig();

const routes = {
  knowledgeBase: "/v1/knowledge-base",
};

export const helpCenterRoutes = {
  getCategories: (): string => `${routes.knowledgeBase}/categories`,
  getCategoryById: (categoryId: string): string =>
    `${routes.knowledgeBase}/categories/${categoryId}`,
  getSectionById: (sectionId: string): string =>
    `${routes.knowledgeBase}/sections/${sectionId}`,
  getArticleById: (articleId: string): string =>
    `${routes.knowledgeBase}/articles/${articleId}`,
};

export const helpCenterBaseUrl = helpCenterApiEndpoint;
